// @flow
import React from 'react';
import styled from 'styled-components';

import { TYPE_SCALE_F6 } from 'styles/type-scale';
import { BORDER_RADIUS_F6 } from 'styles/border-radius';
import { FONT_WEIGHT_700 } from 'styles/font-weight';
import { BORDER_WIDTH_1 } from 'styles/borders';
import { CLARK_PRIMARY, CLARK_TERTIARY, CLARK_ACCENT_SECONDARY, GREY_50 } from 'styles/colors';
import { SPACING_EXTRA_SMALL, SPACING_SMALL } from 'styles/spacing';

const statusTypes = {
  high: CLARK_PRIMARY,
  medium: CLARK_ACCENT_SECONDARY,
  low: CLARK_TERTIARY,
  default: GREY_50,
};

const PillButton = ({ children, status, className }: any) => (
  <ButtonStyle className={className} type="button" status={status}>
    {children}
  </ButtonStyle>
);

const ButtonStyle = styled.button`
  ${TYPE_SCALE_F6};
  ${BORDER_RADIUS_F6};
  ${FONT_WEIGHT_700};
  color: ${props => statusTypes[props.status]};
  border: ${BORDER_WIDTH_1} solid ${props => statusTypes[props.status]};
  background-color: transparent;
  letter-spacing: 0.1em;
  padding: ${SPACING_EXTRA_SMALL} ${SPACING_SMALL};
  text-transform: uppercase;
  text-align: center;
`;

export default PillButton;



// WEBPACK FOOTER //
// ./src/components/shared/pill-button/index.js